// extracted by mini-css-extract-plugin
module.exports = {"error-box":"styles_error-box__vvsLB","error-box__link":"styles_error-box__link__BdB_y"};